import { render } from "./toggle.vue?vue&type=template&id=a95f96dc"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"
script.render = render

export default script